import React from 'react';
import Slider from 'react-slick';

const testimonials = [
  {
    quote: 'The Mila Air Purifier isn’t just another boring appliance I wanted to hide away. It doubles as home decor thanks to the unique design.',
    author: '— Rachael Phillips',
    desgination: 'The Reader’s Digest',
  },
  {
    quote: 'I was not prepared for how much this nifty machine would literally change the way I live in my own home.',
    author: '— Jessica Cherner',
    desgination: 'House Beautiful',
  },
  {
    quote: 'The smartest, most intuitive, and cutting edge air purifier that money can buy.',
    author: '— Nina Huang',
    desgination: 'Travel + Leisure',
  },
];

const ProductTestimonial = () => {
  const settings = {
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    focusOnSelect: true,
    infinite: false,
    autoplaySpeed: 5000,
    speed: 500,
    autoplay: true,

    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: true,
          arrows: false,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <div className='product-testimonial' style={{ '--primary-color': '#F42C52' }}>
      <div className='container container--md'>
        <h2 className='product-testimonial__title'>
          No wonder the press is  stanning on Mila.
        </h2>
        <Slider className='product-testimonial__grid' {...settings}>
          {testimonials.map(({ quote, author, desgination }) => (
            <div className='product-testimonial__item'>
              <div className='product-testimonial__card'>
                <blockquote className='product-testimonial__quote'>
                  <p>{quote}</p>
                  <cite className='product-testimonial__quote-author'>
                    <strong>{author}</strong>
                    {desgination}
                  </cite>
                </blockquote>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
export default ProductTestimonial;
